import {
  SET_ACCOUNT,
  SET_BUSINESS,
  SET_OWNER,
  SET_DEFAULT_BUSINESS,
  SET_DEFAULT_SIZE,
  SET_DEFAULT_CITY,
  SET_DEFAULT_PROVINCE,
} from '../types';

const initialState = {
  owner: { phoneNumber: '', everUsedPOS: false, firstName: '', lastName: '' },
  business: { posCode: '' },
  account: { pin: '', activateDate: new Date().toISOString() },
  defaultBusiness: 'Pilih industri bisnis',
  defaultSize: 'Pilih ukuran bisnis',
  defaultProvince: 'Pilih provinsi',
  defaultCity: 'Pilih kota',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_OWNER:
      return {
        ...state,
        owner: action.payload,
      };
    case SET_BUSINESS:
      return {
        ...state,
        business: action.payload,
      };
    case SET_ACCOUNT:
      return {
        ...state,
        account: action.payload,
      };
    case SET_DEFAULT_BUSINESS:
      return {
        ...state,
        defaultBusiness: action.payload,
      };
    case SET_DEFAULT_SIZE:
      return {
        ...state,
        defaultSize: action.payload,
      };
    case SET_DEFAULT_PROVINCE:
      return {
        ...state,
        defaultProvince: action.payload,
      };
    case SET_DEFAULT_CITY:
      return {
        ...state,
        defaultCity: action.payload,
      };
    default:
      return state;
  }
}
